import type { ReactNode } from "react";
import { Heading } from "@stubhub/broadway-web";
import { typedMemo } from "src/types/typedMemo";
import { seoTableRecipe } from "./styles";

export interface SeoTableColumn<T> {
  header: ReactNode;
  renderCell: (row: T) => ReactNode;
}

interface SeoTableProps<T> {
  rows: readonly T[];
  heading?: ReactNode;
  caption?: ReactNode;
  columns: readonly SeoTableColumn<T>[];
  rowKey: (row: T) => string | number;
}

const SeoTableComponent = <T,>({ rows, heading, caption, columns, rowKey }: SeoTableProps<T>) => {
  const slots = seoTableRecipe();

  return (
    <div className={slots.wrapper}>
      {heading ? (
        <div className={slots.headingWrapper}>
          <Heading as="h2" variant="header">
            {heading}
          </Heading>
        </div>
      ) : null}
      <table className={slots.table}>
        <caption className={slots.caption}>{caption ?? heading}</caption>
        <thead>
          <tr>
            {columns.map((col, i) => (
              <th key={i} scope="col" className={slots.headerCell}>
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={rowKey(row)} className={slots.row}>
              {columns.map((col, i) => (
                <td key={i} className={slots.cell}>
                  {col.renderCell(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const SeoTable = typedMemo(SeoTableComponent);
SeoTable.displayName = "SeoTable";
